import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { Button } from "../components/ui/button";
import Logo from "../components/Logo";
import { useAuth, isStaffUser } from "../context/AuthContext";

export default function Login() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!loading && user) {
      const from = location.state?.from;
      navigate(from && from !== "/login" ? from : isStaffUser(user) ? "/staff" : "/portal", { replace: true });
    }
  }, [user, loading, navigate, location.state]);

  const signIn = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/portal";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="py-16 lg:py-24" data-testid="login-page">
      <div className="max-w-md mx-auto px-4 sm:px-6">
        <div className="bg-surface border border-line rounded-2xl p-8 shadow-sm text-center">
          <div className="flex justify-center mb-6">
            <Logo size={52} showText={false} />
          </div>
          <h1 className="text-2xl font-serif font-semibold text-navy">Client Portal</h1>
          <p className="mt-3 text-sm text-mutedink leading-relaxed">
            Sign in to see your journey, documents, messages, deadlines, and next steps — all in one secure place.
          </p>
          <Button
            onClick={signIn}
            size="lg"
            className="mt-8 w-full bg-teal text-white hover:bg-teal-dark hover:text-white rounded-full"
            data-testid="google-signin-button"
          >
            <svg className="mr-2 h-4 w-4" viewBox="0 0 24 24" aria-hidden="true">
              <path fill="currentColor" d="M12.48 10.92v3.28h7.84c-.24 1.84-.853 3.187-1.787 4.133-1.147 1.147-2.933 2.4-6.053 2.4-4.827 0-8.6-3.893-8.6-8.72s3.773-8.72 8.6-8.72c2.6 0 4.507 1.027 5.907 2.347l2.307-2.307C18.747 1.44 16.133 0 12.48 0 5.867 0 .307 5.387.307 12s5.56 12 12.173 12c3.573 0 6.267-1.173 8.373-3.36 2.16-2.16 2.84-5.213 2.84-7.667 0-.76-.053-1.467-.173-2.053H12.48z"/>
            </svg>
            Sign in with Google
          </Button>
          <p className="mt-5 text-xs text-mutedink flex items-center justify-center gap-1.5">
            <ShieldCheck className="h-3.5 w-3.5 text-sage" /> Secure sign-in. We never see your Google password.
          </p>
        </div>
        <p className="mt-6 text-center text-xs text-mutedink">
          New here? <a href="/start" className="text-teal font-medium hover:underline">Start your journey</a> instead.
        </p>
      </div>
    </div>
  );
}
